import type { TripStatsDto } from '@camper-diary/shared';
import { api } from './client';

export type TripStats = TripStatsDto;

export function getTripStats(tripId: string) {
  return api<TripStats>(`/trips/${encodeURIComponent(tripId)}/stats`);
}
